import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { HttpService } from "../shared/services/http.service";

@Component({
  selector: "app-bulk-tag-dialog",
  templateUrl: "./bulk-tag-dialog.component.html",
  styleUrls: ["./bulk-tag-dialog.component.scss"],
  standalone: false
})
export class BulkTagDialogComponent implements OnInit {
  @Input() selectedClientIds: any[] = []
  @Input() selectedClients: any[] = []
  @Output() close = new EventEmitter<void>()
  @Output() applied = new EventEmitter<void>()

  bulkTagMode: 'add' | 'remove' = 'add'
  bulkTagFilter = ''
  bulkTagSelections: string[] = []
  bulkTagApplying = false
  tagCoverageData: {id: string, tag: string, count: number}[] = []
  localTags: {id: string, tag: string}[] = []

  get selectedCount(): number {
    return this.selectedClientIds.length
  }

  get filteredBulkTags(): {id: string, tag: string}[] {
    if (!this.bulkTagFilter) return this.localTags
    return this.localTags.filter(t => t.tag.toLowerCase().includes(this.bulkTagFilter.toLowerCase()))
  }

  get showCreateOption(): boolean {
    if (this.bulkTagMode !== 'add') return false
    const name = this.bulkTagFilter.trim()
    if (!name) return false
    return !this.localTags.some(t => t.tag.toLowerCase() === name.toLowerCase())
  }

  isBulkTagSelected(tagId: string): boolean {
    return this.bulkTagSelections.includes(tagId)
  }

  toggleBulkTag(tagId: string, event: MouseEvent) {
    event.stopPropagation()
    if (this.bulkTagSelections.includes(tagId)) {
      this.bulkTagSelections = this.bulkTagSelections.filter(id => id !== tagId)
    } else {
      this.bulkTagSelections = [...this.bulkTagSelections, tagId]
    }
  }

  tagCoverage(tagId: string): number {
    return this.tagCoverageData.find(t => t.id === tagId)?.count ?? 0
  }

  coverageLabel(tagId: string): string {
    const coverage = this.tagCoverage(tagId)
    const total = this.selectedCount
    if (coverage === 0) return ''
    if (coverage === total) return `All ${total} already have this`
    return `${coverage} of ${total} already have this`
  }

  async createAndSelectTag() {
    const name = this.bulkTagFilter.trim()
    if (!name) return
    const resp: any = await this.httpService.postAsync('htag/create', { tag: name })
    if (!resp.success) return
    const newTag = { id: resp.id, tag: name }
    this.localTags = [...this.localTags, newTag]
    this.bulkTagSelections = [...this.bulkTagSelections, newTag.id]
    this.bulkTagFilter = ''
  }

  async applyBulkTags() {
    if (this.bulkTagSelections.length === 0 || this.bulkTagApplying) return
    this.bulkTagApplying = true
    try {
      const clientIds = [...this.selectedClientIds]
      const endpoint = this.bulkTagMode === 'add' ? 'htag/assign' : 'htag/unassign'
      for (const tagId of this.bulkTagSelections) {
        await this.httpService.postAsync(endpoint, { tagId, clientIds })
      }
      this.applied.emit()
    } finally {
      this.bulkTagApplying = false
    }
  }

  constructor(private httpService: HttpService) {}

  async ngOnInit() {
    const tagsResp: any = await this.httpService.postAsync('htag/list', {})
    this.localTags = tagsResp?.data || []
    const tagIds = this.localTags.map(t => t.id)
    const res: any = await this.httpService.postAsync('htag/coverage', { tagIds, clientIds: this.selectedClientIds })
    this.tagCoverageData = res?.data || []
  }
}
